module.exports = __webpack_public_path__ + "static/media/download_icon.69f8553a.svg";